export interface FindingRemediationInput {
  recommendation?: string | null;
  sourceLocation?: string | null;
  requirementReference?: string | null;
}

export function isTransitionReference(reference: string): boolean {
  return /(?:Regulation\s*\(EU\)\s*)?2023\/1230/i.test(reference);
}

export function findingRemediation(finding: FindingRemediationInput): {
  nextAction: string;
  location: string;
  reference: string;
} {
  const nextAction = finding.recommendation?.trim() || 'Review this finding.';
  const sourceLocation = finding.sourceLocation?.trim();
  return {
    nextAction,
    location: sourceLocation
      ? `Update ${sourceLocation}.`
      : 'Update the section identified at the source location shown above.',
    reference:
      finding.requirementReference?.trim() || 'Standard reference unavailable',
  };
}
